module.exports = __webpack_public_path__ + "img/list_7.5f34cc8c.jpg";